'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var genderValues = {
    1: 'MALE',
    2: 'FEMALE'
};

exports.default = genderValues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/gender/genderValues.js
// module id = 1371
// module chunks = 0